import React from 'react';
import { BarChart2, FileText, Download, Filter, Calendar, CheckSquare, Users, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Reports() {
  const recentReports = [{
    id: 1,
    title: 'Committee Performance Report - Q2 2023',
    type: 'Performance',
    date: '2023-07-15',
    downloads: 24
  }, {
    id: 2,
    title: 'Task Completion Analysis - August 2023',
    type: 'Task',
    date: '2023-09-02',
    downloads: 18
  }, {
    id: 3,
    title: 'Meeting Attendance Summary - Q3 2023',
    type: 'Meeting',
    date: '2023-08-30',
    downloads: 12
  }, {
    id: 4,
    title: 'Committee Budget Utilization Report',
    type: 'Budget',
    date: '2023-08-15',
    downloads: 31
  }];
  const reportTemplates = [{
    id: 1,
    title: 'Committee Performance Report',
    description: 'Analyze committee activities, task completion rates, and overall performance metrics.',
    icon: Users
  }, {
    id: 2,
    title: 'Task Completion Report',
    description: 'Track task status, completion rates, and deadline adherence across committees.',
    icon: CheckSquare
  }, {
    id: 3,
    title: 'Meeting Attendance Report',
    description: 'Monitor meeting attendance, participation rates, and engagement metrics.',
    icon: Calendar
  }, {
    id: 4,
    title: 'Custom Report',
    description: 'Create a customized report with specific metrics, filters, and visualization options.',
    icon: BarChart2
  }];
  return <div data-id="element-1760">
      <div className="flex justify-between items-center mb-6" data-id="element-1761">
        <h1 className="text-2xl font-bold" data-id="element-1762">Reports & Analytics</h1>
        <Link to="/reports/generate" className="px-4 py-2 bg-orange-500 text-white rounded-md hover:bg-orange-600 transition-colors flex items-center" data-id="element-1763">
          <BarChart2 size={18} className="mr-2" data-id="element-1764" />
          Generate Report
        </Link>
      </div>

      {/* Dashboard Summary */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-1765">
        <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-1766">
          <div className="flex items-center justify-between mb-4" data-id="element-1767">
            <h3 className="text-lg font-semibold" data-id="element-1768">Task Completion</h3>
            <div className="h-10 w-10 bg-green-100 rounded-full flex items-center justify-center" data-id="element-1769">
              <CheckSquare size={20} className="text-green-500" data-id="element-1770" />
            </div>
          </div>
          <div className="text-3xl font-bold mb-2" data-id="element-1771">78%</div>
          <div className="w-full bg-gray-200 rounded-full h-2.5 mb-1" data-id="element-1772">
            <div className="h-2.5 rounded-full bg-green-500" style={{
            width: '78%'
          }} data-id="element-1773"></div>
          </div>
          <p className="text-sm text-gray-500" data-id="element-1774">Overall task completion rate</p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-1775">
          <div className="flex items-center justify-between mb-4" data-id="element-1776">
            <h3 className="text-lg font-semibold" data-id="element-1777">Meeting Attendance</h3>
            <div className="h-10 w-10 bg-blue-100 rounded-full flex items-center justify-center" data-id="element-1778">
              <Users size={20} className="text-blue-500" data-id="element-1779" />
            </div>
          </div>
          <div className="text-3xl font-bold mb-2" data-id="element-1780">92%</div>
          <div className="w-full bg-gray-200 rounded-full h-2.5 mb-1" data-id="element-1781">
            <div className="h-2.5 rounded-full bg-blue-500" style={{
            width: '92%'
          }} data-id="element-1782"></div>
          </div>
          <p className="text-sm text-gray-500" data-id="element-1783">Average meeting attendance</p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-1784">
          <div className="flex items-center justify-between mb-4" data-id="element-1785">
            <h3 className="text-lg font-semibold" data-id="element-1786">Active Committees</h3>
            <div className="h-10 w-10 bg-purple-100 rounded-full flex items-center justify-center" data-id="element-1787">
              <Users size={20} className="text-purple-500" data-id="element-1788" />
            </div>
          </div>
          <div className="text-3xl font-bold mb-2" data-id="element-1789">5/6</div>
          <div className="w-full bg-gray-200 rounded-full h-2.5 mb-1" data-id="element-1790">
            <div className="h-2.5 rounded-full bg-purple-500" style={{
            width: '83%'
          }} data-id="element-1791"></div>
          </div>
          <p className="text-sm text-gray-500" data-id="element-1792">Committees currently active</p>
        </div>
      </div>

      {/* Report Templates */}
      <div className="bg-white rounded-lg shadow-sm p-6 mb-8" data-id="element-1793">
        <h2 className="text-lg font-semibold mb-4" data-id="element-1794">Report Templates</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1795">
          {reportTemplates.map(template => <Link key={template.id} to="/reports/generate" className="border border-gray-200 rounded-lg p-4 hover:border-orange-500 hover:shadow-md transition-all flex" data-id="element-1796">
              <div className="h-12 w-12 bg-orange-100 rounded-full flex items-center justify-center mr-4" data-id="element-1797">
                <template.icon size={24} className="text-orange-500" data-id="element-1798" />
              </div>
              <div className="flex-1" data-id="element-1799">
                <h3 className="font-medium mb-1" data-id="element-1800">{template.title}</h3>
                <p className="text-sm text-gray-500 mb-2" data-id="element-1801">
                  {template.description}
                </p>
                <div className="text-orange-500 text-sm font-medium flex items-center" data-id="element-1802">
                  Generate Report <ArrowRight size={14} className="ml-1" data-id="element-1803" />
                </div>
              </div>
            </Link>)}
        </div>
      </div>

      {/* Recent Reports */}
      <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-1804">
        <div className="flex justify-between items-center mb-4" data-id="element-1805">
          <h2 className="text-lg font-semibold" data-id="element-1806">Recent Reports</h2>
          <div className="relative" data-id="element-1807">
            <Filter size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-1808" />
            <select className="pl-10 pr-4 py-2 border border-gray-200 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500 appearance-none" data-id="element-1809">
              <option data-id="element-1810">All Report Types</option>
              <option data-id="element-1811">Performance Reports</option>
              <option data-id="element-1812">Task Reports</option>
              <option data-id="element-1813">Meeting Reports</option>
              <option data-id="element-1814">Budget Reports</option>
            </select>
          </div>
        </div>
        <div className="overflow-x-auto" data-id="element-1815">
          <table className="w-full" data-id="element-1816">
            <thead data-id="element-1817">
              <tr className="bg-gray-50" data-id="element-1818">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1819">
                  Report Name
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1820">
                  Type
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1821">
                  Generated Date
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1822">
                  Downloads
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1823">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-1824">
              {recentReports.map(report => <tr key={report.id} data-id="element-1825">
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1826">
                    <div className="flex items-center" data-id="element-1827">
                      <FileText size={16} className="text-gray-500 mr-2" data-id="element-1828" />
                      <span className="font-medium" data-id="element-1829">{report.title}</span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1830">
                    <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${report.type === 'Performance' ? 'bg-blue-100 text-blue-800' : report.type === 'Task' ? 'bg-green-100 text-green-800' : report.type === 'Meeting' ? 'bg-purple-100 text-purple-800' : 'bg-orange-100 text-orange-800'}`} data-id="element-1831">
                      {report.type}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1832">
                    <div className="text-sm text-gray-500" data-id="element-1833">{report.date}</div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1834">
                    <div className="text-sm text-gray-500" data-id="element-1835">
                      {report.downloads}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium" data-id="element-1836">
                    <div className="flex space-x-3" data-id="element-1837">
                      <button className="text-blue-500 hover:text-blue-700" data-id="element-1838">
                        <FileText size={16} data-id="element-1839" />
                      </button>
                      <button className="text-green-500 hover:text-green-700" data-id="element-1840">
                        <Download size={16} data-id="element-1841" />
                      </button>
                      <button className="text-orange-500 hover:text-orange-700" data-id="element-1842">
                        <BarChart2 size={16} data-id="element-1843" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}